/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics cookies — Help us understand how users interact with our tools (e.g., Google Analytics).`)
};

const es_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de análisis — Nos ayudan a entender cómo los usuarios interactúan con nuestras herramientas (ej., Google Analytics).`)
};

const de_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse-Cookies — Helfen uns zu verstehen, wie Benutzer mit unseren Werkzeugen interagieren (z.B. Google Analytics).`)
};

const nl_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytische cookies — Helpen ons te begrijpen hoe gebruikers met onze tools omgaan (bijv. Google Analytics).`)
};

const fr_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies d’analyse — Nous aident à comprendre comment les utilisateurs interagissent avec nos outils (ex. Google Analytics).`)
};

const it_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie analitici — Ci aiutano a capire come gli utenti interagiscono con i nostri strumenti (es. Google Analytics).`)
};

const pt_br2_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de análise — Nos ajudam a entender como os usuários interagem com nossas ferramentas (ex.: Google Analytics).`)
};

const pt_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de análise — Ajudam-nos a compreender como os utilizadores interagem com as nossas ferramentas (ex.: Google Analytics).`)
};

const ja_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析Cookie — ユーザーのツール利用状況を理解するのに役立ちます（例: Google Analytics）。`)
};

const zh_privacy_cookie_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析Cookie — 帮助我们了解用户如何与我们的工具互动（如Google Analytics）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_cookie_analytics = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_cookie_analytics(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_cookie_analytics", locale)
	if (locale === "en") return en_privacy_cookie_analytics(inputs)
	if (locale === "es") return es_privacy_cookie_analytics(inputs)
	if (locale === "de") return de_privacy_cookie_analytics(inputs)
	if (locale === "nl") return nl_privacy_cookie_analytics(inputs)
	if (locale === "fr") return fr_privacy_cookie_analytics(inputs)
	if (locale === "it") return it_privacy_cookie_analytics(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_cookie_analytics(inputs)
	if (locale === "pt") return pt_privacy_cookie_analytics(inputs)
	if (locale === "ja") return ja_privacy_cookie_analytics(inputs)
	return zh_privacy_cookie_analytics(inputs)
};